import { HomeStudentHistoryPage } from './HomeStudentHistoryPage';
export default HomeStudentHistoryPage;
